import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/components/client/TermsClient.tsx");
